//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    segment: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      default: false
    },
    firstSegment: {
      type: Boolean,
      default: false
    },
    lastSegment: {
      type: Boolean,
      default: false
    },
    isDivide: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    pointTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    layingTypes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    const self = this
    return {
      readonlyLocal: {
        get full () {
          return self.readonly
        },
        start: false,
        end: false
      },

      optionsLayingTypes: [],
      optionsStartPointTypes: [],
      optionsEndPointTypes: [],

      loading: false
    }
  },
  computed: {
    disableBtnSave: function () {
      if (this.readonlyLocal.full) {
        return true
      }
      let disableBtnSave = !this.segment.start || (this.needAdditionalId(this.segment.start) ? !this.segment.startId : false) || !this.segment.layingType
      if (!this.isDivide) {
        disableBtnSave = disableBtnSave || !this.segment.end || (this.needAdditionalId(this.segment.end) ? !this.segment.endId : false)
      }
      return disableBtnSave
    }
  },
  watch: {
    opened: {
      handler: function () {
        if (this.opened) {
          this.readonlyLocal.start = this.readonly || !this.firstSegment && !!this.segment.start
          this.readonlyLocal.end = this.readonly || !this.lastSegment && !!this.segment.end
        } else {
          this.readonlyLocal.start = false
          this.readonlyLocal.end = false
        }
      },
      immediate: true
    }
  },
  methods: {
    onSave: function () {
      this.$emit('save', this.segment)
    },
    onClose: function () {
      this.$emit('close')
    },
    needAdditionalId: function (pointName) {
      const point = this.pointTypes.find(point => point.name == pointName)
      if (point) {
        return point.needAdditionalId
      }
    },
    filterStartPointTypes (val, update) {
      if (val === '') {
        update(() => {
          this.optionsStartPointTypes = this.pointTypes
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsStartPointTypes = this.pointTypes.filter((point) => {
          return point.name.toLowerCase().indexOf(str) > -1
        })
      })
    },
    filterEndPointTypes (val, update) {
      if (val === '') {
        update(() => {
          this.optionsEndPointTypes = this.pointTypes
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsEndPointTypes = this.pointTypes.filter((point) => {
          return point.name.toLowerCase().indexOf(str) > -1
        })
      })
    },
    filterLayingTypes (val, update) {
      if (val === '') {
        update(() => {
          this.optionsLayingTypes = this.layingTypes
        })
        return
      }
      update(() => {
        const str = val.toLowerCase()
        this.optionsLayingTypes = this.layingTypes.filter((laying) => {
          return laying.name.toLowerCase().indexOf(str) > -1
        })
      })
    }
  }
}

